import {skeletonGet} from './skeleton/skeletonGet';

const droppingOddsEndpoint = 'mo/dropping-odds'

export const GetCurrentOddsCall = (bookmaker: number): Promise<any> => {
    return skeletonGet('classic/' + bookmaker.toString(), droppingOddsEndpoint);
};